<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/advertisers'">Advertisers</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add advertiser</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit advertiser</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3">
        <h2 class="fw-bold fs-6 mb-0">Informations</h2>
        <i class="bi bi-person-bounding-box text-primary me-2"></i>
      </div>
      <div class="row g-3 mb-3">
        <div class="col">
          <label for="companyName" class="form-label">Company Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="companyName" placeholder="Enter company name"
              formControlName="companyName">
          </div>
        </div>
        <div class="col">
          <label for="First Name" class="form-label">First Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-person"></i></span>
            <input type="text" class="form-control" id="First Name" placeholder="First name"
              formControlName="firstname">
          </div>
        </div>
        <div class="col">
          <label for="Last Name" class="form-label">Last Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
            <input type="text" class="form-control" id="Last Name" placeholder="Last name" formControlName="lastname">
          </div>
        </div>
        <div class="col">
          <label for="nickName" class="form-label">Nick Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-tag"></i></span>
            <input type="text" class="form-control" id="nickName" placeholder="Nick name" formControlName="nickname">
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="address" class="form-label">Address</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
            <input type="text" class="form-control" id="address" placeholder="Street address" formControlName="address">
          </div>
        </div>
        <div class="col">
          <label for="zipCode" class="form-label">Zip Code</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-mailbox"></i></span>
            <input type="text" class="form-control" id="zipCode" placeholder="Zip code" formControlName="zipCode">
          </div>
        </div>
        <div class="col">
          <label for="state" class="form-label">State</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-map"></i></span>
            <input type="text" class="form-control" id="state" placeholder="State" formControlName="state">
          </div>
        </div>
        <div class="col">
          <label for="city" class="form-label">City</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="city" placeholder="City" formControlName="city">
          </div>
        </div>
        <div class="col">
          <label for="country" class="form-label">Country</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-flag"></i></span>
            <select id="country" class="form-select" formControlName="country">
              <option [value]="null" disabled>Select country</option>
              @for (country of countries; track country) {
                <option [value]="country.isoCode">{{ country.name }}</option>
              }
            </select>
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="phoneNumber" class="form-label">Phone Number</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-telephone"></i></span>
            <input type="text" class="form-control" id="phoneNumber" placeholder="Phone number"
              formControlName="phoneNumber">
          </div>
        </div>
        <div class="col">
          <label for="emailAddress" class="form-label">Email Address</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-envelope"></i></span>
            <input type="email" class="form-control" id="emailAddress" placeholder="Email address"
              formControlName="email" autocomplete="new-password">
          </div>
        </div>
        <div class="col">
          <label for="website" class="form-label">Website</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-globe"></i></span>
            <input type="url" class="form-control" id="website" placeholder="Website URL" formControlName="websiteUrl">
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="companyNumber" class="form-label">Company Number</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-123"></i></span>
            <input type="text" class="form-control" id="companyNumber" placeholder="Company number"
              formControlName="companyNumber">
          </div>
        </div>
        <div class="col">
          <label for="vatNumber" class="form-label">VAT Number</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-percent"></i></span>
            <input type="text" class="form-control" id="vatNumber" placeholder="VAT number" formControlName="vatNumber">
          </div>
        </div>
        <div class="col">
          <label for="status" class="form-label">Status</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-toggle2-off"></i></span>
            <select id="status" class="form-select" formControlName="status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      @if (!isCreate()) {
        <div>
          <div class="row g-3 mb-3">
            <div class="col">
              <label class="form-label">Upload Logo</label>
              <div class="row">
                <div class="col">
                  <label (drop)="onDropUpload($event)"
                    (dragover)="onDragOver($event)"
                    class="d-block upload-area border border-1 rounded p-4 text-center bg-light">
                    <i class="bi bi-cloud-arrow-up fs-1 text-primary"></i>
                    <p class="mt-3 mb-0 fw-bold">Drag and drop your logo here or click to upload</p>
                    <input type="file" id="logoUpload" class="form-control d-none" accept="image/*"
                      (change)="onClickLogoUpload($event)">
                    <button type="button" class="btn btn-primary mt-3 fw-bold">Upload Logo</button>
                  </label>
                </div>
                @if (logo?.data || advertiser?.logo) {
                  <div class="col-auto">
                    <img [ngSrc]="logo?.data || imageService.getImageUrl($safeNavigationMigration(advertiser?.logo), 180, 180)" width="180" height="180" alt="" priority />
                  </div>
                }
              </div>
            </div>
          </div>
          <div
            class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3 mt-4">
            <h2 class="fw-bold fs-6 mb-0">Compliance Documents</h2><i
          class="bi bi-person-bounding-box text-primary me-2"></i></div>
          <div class="row g-3">
            @if (advertiser) {
              <app-compliance-documents #compliance [model]="advertiser"></app-compliance-documents>
            }
          </div>
        </div>
      }

      <div class="col-12 text-end mt-5">
        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
          @if (isCreate()) {
            <span>Create</span>
          }
          @if (!isCreate()) {
            <span>Update</span>
          }
        </button>
      </div>

    </form>
  </div>
</div>
